module.exports = __webpack_public_path__ + "static/media/snow_austria.86813be7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/snow_austria.jpg
// module id = 467
// module chunks = 0